import React, {useState} from 'react';

const TEXT_PREVIEW_LENGTH = 220;

export default function ProjectDetail({project, onClose}) {
    const images = project.images && project.images.length > 0 ? project.images : [project.image];
    const [index, setIndex] = useState(0);
    const [expanded, setExpanded] = useState(false);

    const next = () => setIndex((i) => (i + 1) % images.length);
    const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);

    const isLongText = project.description.length > TEXT_PREVIEW_LENGTH;
    const displayedText = !isLongText || expanded
        ? project.description
        : project.description.slice(0, TEXT_PREVIEW_LENGTH).trim() + '…';

    return (
        <div style={overlayStyle} onClick={onClose}>
            <div style={panelStyle} className="detail-panel" onClick={(e) => e.stopPropagation()}>
                <button onClick={onClose} style={closeButtonStyle} aria-label="Schließen">
                    ×
                </button>

                <div style={imageColStyle} className="detail-image-col">
                    <img src={images[index]} alt={`${project.title} – Bild ${index + 1}`} style={imageStyle}/>

                    {images.length > 1 && (
                        <>
                            <button onClick={prev} style={{...navButtonStyle, left: '12px'}}
                                    aria-label="Vorheriges Bild">
                                ‹
                            </button>
                            <button onClick={next} style={{...navButtonStyle, right: '12px'}}
                                    aria-label="Nächstes Bild">
                                ›
                            </button>

                            <div style={dotsStyle}>
                                {images.map((_, i) => (
                                    <span
                                        key={i}
                                        onClick={() => setIndex(i)}
                                        style={{...dotStyle, opacity: i === index ? 1 : 0.35}}
                                    />
                                ))}
                            </div>
                        </>
                    )}
                </div>

                <div style={textColStyle} className="detail-text-col">
                    <p style={titleStyle}>{project.title}</p>
                    <p style={descriptionStyle}>{displayedText}</p>

                    {isLongText && (
                        <button onClick={() => setExpanded((e) => !e)} style={expandButtonStyle}>
                            {expanded ? '▲ weniger anzeigen' : '▼ mehr anzeigen'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

const overlayStyle = {
    position: 'absolute',
    inset: 0,
    background: 'rgba(255,255,255,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
};

const panelStyle = {
    position: 'relative',
    display: 'flex',
    width: '80%',
    maxWidth: '900px',
    minHeight: '420px',
    background: '#ffffff',
    border: '1px solid #eaeaea',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0,0,0,0.05)',
    color: '#111',
};

const imageColStyle = {position: 'relative', flex: '1', background: '#f5f5f5'};
const imageStyle = {width: '100%', height: '100%', objectFit: 'cover', display: 'block'};
const textColStyle = {width: "30%", padding: '40px', boxSizing: 'border-box'};

const titleStyle = {margin: '0 0 12px', fontSize: '28px', color: 'black'};
const descriptionStyle = {fontSize: 12, lineHeight: 1.6, color: '#444'};

const expandButtonStyle = {
    border: 'none',
    background: 'none',
    color: '#555',
    cursor: 'pointer',
    padding: 0,
    marginTop: '8px',
    fontSize: '14px',
};

const navButtonStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    border: 'none',
    background: 'transparent',
    color: '#111',
    fontSize: '40px',
    lineHeight: 1,
    cursor: 'pointer',
};

const dotsStyle = {
    position: 'absolute',
    bottom: '16px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '8px',
};

const dotStyle = {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: 'white',
    cursor: 'pointer',
};

const closeButtonStyle = {
    position: 'absolute',
    top: '16px',
    right: '16px',
    width: '36px',
    height: '36px',
    border: 'none',
    color: '#111',
    fontSize: '20px',
    lineHeight: 1,
    cursor: 'pointer',
    zIndex: 1,
};
